export default __webpack_public_path__ + "assets/images/2036e0a2e09dcd977656f832bf2c1d0c.svg";